import { TaskType } from '../../types/interfaces';
import { TaskProcessingProcessCardModel } from '../../types/interfaces/TaskProcessingProcessCardModel';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import ServiceResult from './interfaces/ServiceResult';
import ITaskTypesService from './interfaces/TaskTypesService';

class TaskTypesService
  extends BaseService<TaskType>
  implements ITaskTypesService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'TaskTypes');
  }

  getWithTaskProcessingProcesses(
    id: number | undefined
  ): ServiceResult<TaskProcessingProcessCardModel> {
    const apiCalls = this._apiCalls.beginApiCalls();
    if (!id) {
      return {
        result: apiCalls.TaskProcessingProcesses.getForSelection().then(
          (x) => ({ taskType: undefined, taskProcessingProcesses: x })
        ),
        cancel: apiCalls.cancelAllCalls
      };
    }
    const resultPromise = Promise.all([
      apiCalls.TaskTypes.get(id),
      apiCalls.TaskProcessingProcesses.getForSelection()
    ]).then(
      ([
        taskType,
        taskProcessingProcesses
      ]): TaskProcessingProcessCardModel => ({
        taskType,
        taskProcessingProcesses
      })
    );
    return { result: resultPromise, cancel: apiCalls.cancelAllCalls };
  }
}

export default TaskTypesService;
